(() => {
  'use strict';
  if (window.YoLinkHeaderController) {
    window.YoLinkHeaderController.scan();
    return;
  }
  const instances = new Map();
  const mount = header => {
    if (instances.has(header)) return;
    const controller = new AbortController(), options = { signal: controller.signal };
    const search = header.querySelector('[data-yb-search]');
    const menu = header.querySelector('#yb-mobile-nav');
    const toggle = header.querySelector('[data-yb-menu]');
    const hasMenu = Boolean(menu && toggle);
    const listen = (target, type, handler) => target?.addEventListener(type, event => {
      if (!controller.signal.aborted) handler(event);
    }, options);
    const closeMenu = (focusTarget = toggle) => {
      if (!hasMenu) return;
      if (menu.contains?.(document.activeElement)) focusTarget?.focus();
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation');
    };
    if (hasMenu) listen(toggle, 'click', () => {
      const open = menu.hidden;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      if (open && search) search.open = false;
    });
    listen(search, 'toggle', () => {
      if (!search.open) return;
      closeMenu();
      search.querySelector('input[type=search]')?.focus();
    });
    listen(search, 'focusout', event => {
      if (!search.contains(event.relatedTarget)) search.open = false;
    });
    listen(document, 'click', event => {
      if (header.contains(event.target)) return;
      closeMenu();
      if (search) search.open = false;
    });
    listen(header, 'keydown', event => {
      if (event.key !== 'Escape') return;
      if (search?.open) {
        search.open = false;
        search.querySelector('summary')?.focus();
      } else if (hasMenu && !menu.hidden) {
        closeMenu();
        toggle.focus();
      }
    });
    listen(matchMedia('(max-width:620px)'), 'change', event => {
      closeMenu(event.matches ? toggle : header.querySelector('.yb-brand') || toggle);
    });
    instances.set(header, () => {
      controller.abort();
      if (menu) menu.hidden = true;
      if (search) search.open = false;
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation');
      }
      instances.delete(header);
    });
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-yl-header]')) mount(scope);
    scope.querySelectorAll('[data-yl-header]').forEach(mount);
  };
  window.YoLinkHeaderController = { scan };
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target === root || event.target.contains(root)) dispose();
  });
})();
